<template>
    <div>
        <DataTable :value="eventTypes" lazy paginator dataKey="id"
                   v-model:rows="searchCriteria.page.limit" v-model:first="searchCriteria.page.offset" removableSort
                   :totalRecords="totalRecords" :loading="loading" @page="onPage"
                   @sort="onPage" :rowsPerPageOptions="[5,10,20,50]"
                   selection-mode="single" v-model:selection="selectedTableElement" @row-click="onRowSelect"
                   filterDisplay="row" v-model:filters="searchCriteria" @update:filters="search" scrollable
                   scrollHeight="calc(100vh - 300px)">
            <Column field="description" :header="$t('message.eventType.name')" :sortable="true"
                    filterField="description" :showFilterMenu="false"
                    :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    {{ data.description }}
                </template>
                <template #filter>
                    <CustomInputText name="description" v-model="searchCriteria.description" class="mb-0"
                                     @update:modelValue="search"/>
                </template>
            </Column>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { searchEventType, searchEventTypeCount } from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomSelectOneYesNo from "@/components/form/CustomSelectOneYesNo.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";

export default {
    name: "EventTypeTable",
    components: {
        CustomInputText,
        Button,
        Column,
        DataTable,
        CustomSelectOneYesNo,
    },

    props: {
        modelValue: null,
    },

    emits: ["update:modelValue", "showForm"],

    data() {
        return {
            loading: false,
            totalRecords: 0,
            eventTypes: [],
            searchCriteria: this.getClearSearchCriteria(),
            selectedTableElement: null,
        };
    },

    mounted() {
        this.updateTotalRecords();
        this.onPage(this.getFirstPage());
    },

    methods: {
        search() {
            this.onPage(this.getFirstPage());
            this.updateTotalRecords();
        },

        onPage(event) {
            this.loading = true;
            this.searchCriteria.page.offset = event.first;
            this.searchCriteria.page.limit = event.rows;
            this.searchCriteria.page.sortField = event.sortField;
            this.searchCriteria.page.sortOrder = event.sortOrder;

            searchEventType({ body: this.searchCriteria }).then((response) => {
                this.eventTypes = response.data;
                this.loading = false;
            });
        },

        updateTotalRecords() {
            searchEventTypeCount({ body: this.searchCriteria }).then((response) => {
                this.totalRecords = response.data;
            });
        },

        getFirstPage() {
            return {
                first: this.searchCriteria.page.offset,
                rows: this.searchCriteria.page.limit,
            };
        },

        onRowSelect(event) {
            ScrollToUtils.scrollToElement();
            this.$emit("showForm");
            this.selectedEvent = event.data;
        },

        getClearSearchCriteria() {
            return {
                code: "",
                name: "",
                abbreviation: "",
                page: {
                    limit: 10,
                    offset: 0,
                    sortField: null,
                    sortOrder: null,
                },
            };
        },

        addNewEvent() {
            this.selectedTableElement = null;
        },

        reloadTable() {
            this.search();
        },
    },

    computed: {
        selectedEvent: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
